import { useEffect, useRef } from "react";

import { isSimilarwebExtensionInstalled } from "app/UtilitiesAndConstants/UtilityFunctions/extensionDetection";

export const useExtensionPromotionEffect = (canPromote: () => boolean, onPromote: () => void): void => {
    const canPromoteRef = useRef(canPromote);
    const onPromoteRef = useRef(onPromote);

    canPromoteRef.current = canPromote;
    onPromoteRef.current = onPromote;

    useEffect(() => {
        let isActive = true;

        if (!canPromoteRef.current()) {
            return;
        }

        void isSimilarwebExtensionInstalled().then((isInstalled) => {
            if (!isActive || isInstalled) {
                return;
            }

            onPromoteRef.current();
        });

        return () => {
            isActive = false;
        };
    }, []);
};
